import { CreditCard, LocalAtm } from "@mui/icons-material";
import { Button, Container, TextField } from "@mui/material";
import { useIsMounted } from "hooks";
import {
  useFeaturedProduct,
  useProducts,
  useSuppliers,
} from "hooks/useDataFetch";

import React, { Fragment, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import Lottie from "react-lottie";
import { emptyList, searchingProduct } from "asset/animations";

const SearchUi = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [featured, setFeatured] = useState([]);

  const featuredProduct = useFeaturedProduct();
  // console.log(featuredProduct);

  const product = useProducts();
  const suppliers = useSuppliers();

  const isMounted = useIsMounted();

  useEffect(() => {
    if (featuredProduct?.data) {
      setFeatured(featuredProduct?.data?.slice(0, 4));
    }
  }, [isMounted, featuredProduct?.data]);

  const handleSearch = () => {
    try {
      if (!searchQuery.trim()) {
        setResults([]);
      }
      setSearched(true);
      setLoading(true);

      const productResults = product?.data?.filter((product) => {
        return product?.name.toLowerCase().includes(searchQuery.toLowerCase());
      });
      const supplierResults = suppliers?.data?.filter((supplier) => {
        return supplier?.name.toLowerCase().includes(searchQuery.toLowerCase());
      });
      let searchResults = productResults.concat(supplierResults);

      setResults(searchResults);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
      });
    }
  };

  useEffect(() => {
    if (isMounted.current) {
      searchQuery.length === 0 && setSearched(false);
    }
  }, [searchQuery, isMounted]);

  const searchLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: searchingProduct,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const noResultFound = {
    loop: false,
    autoplay: true,
    animationData: emptyList,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // console.log(results);

  return (
    <Container maxWidth="md" className="product-search">
      <div className="product-search-field flex-row align-items-center ">
        <TextField
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e?.target?.value);
          }}
          onKeyDown={(e) => {
            if (e?.key === "Enter") {
              setSearchQuery(e?.target?.value);
              handleSearch();
            }
          }}
          placeholder="search"
          className="w-100"
        />{" "}
        <Button className="product-search-btn" onClick={handleSearch}>
          Search
        </Button>
      </div>
      <div className="product-search-container flex-column gap-1">
        {loading ? (
          <div className="product-search-loading">
            <Lottie options={searchLottieOptions} height={350} width={350} />
          </div>
        ) : results.length > 0 ? (
          results.map((result, index) => {
            return (
              <Fragment key={index}>
                {result?.supplierType ? (
                  <NavLink to={`/supplier/${result?.id}`}>
                    <span className="navbar-search-results-item w-100 flex-row  gap-1">
                      <span className="navbar-search-results-item-img flex-row align-items-center justify-content-center">
                        <img src={result?.image} alt="supplier" />
                      </span>

                      <span className="navbar-search-results-item-details flex-column gap-1">
                        <h3 className="navbar-search-results-item-details-name">
                          {result?.name}
                        </h3>

                        <span className="search-item-quantity flex-column">
                          <p className="search-item-quantity-p flex-row align-items-center gap-1 ">
                            Minimum Order :{" "}
                            <span className="search-item-quantity-p-span">
                              {result?.minOrder} SAR
                            </span>
                          </p>
                          <p className="search-item-quantity-p flex-row align-items-center gap-1 ">
                            Location
                            <span className="search-item-quantity-p-span">
                              {result?.location}
                            </span>
                          </p>
                          <p className="search-item-quantity-p flex-row align-items-center gap-1 ">
                            Payment :{" "}
                            <span className="search-item-quantity-p-span flex-row align-items-center">
                              <div className="payments-details-card">
                                {result.payments && (
                                  <p className=" flex-row align-items-center ">
                                    {result.payments?.cash && (
                                      <span className="flex-row align-items-center">
                                        <LocalAtm />
                                      </span>
                                    )}
                                    {result.payments?.card && (
                                      <span className="flex-row align-items-center">
                                        <CreditCard />
                                      </span>
                                    )}
                                  </p>
                                )}
                              </div>
                            </span>
                          </p>
                          <p className="search-item-quantity-p flex-row align-items-center gap-1 ">
                            Supplier Type
                            <span className="search-item-quantity-p-span">
                              {result?.supplierType}
                            </span>
                          </p>
                        </span>

                        {/* <span className="search-item-pricing">SAR 500</span> */}
                      </span>
                    </span>
                  </NavLink>
                ) : (
                  <NavLink to={`/product/${result?.id}`}>
                    <span className="navbar-search-results-item w-100 flex-row  gap-1">
                      <span className="navbar-search-results-item-img flex-row align-items-center justify-content-center">
                        <img src={result?.images[0]?.url} alt="product" />
                      </span>

                      <span className="navbar-search-results-item-details flex-column gap-1">
                        <h3 className="navbar-search-results-item-details-name">
                          {result?.name}
                        </h3>

                        <span className="search-item-quantity flex-column">
                          <p className="search-item-quantity-p flex-row align-items-center  ">
                            Quantity :{" "}
                            <span className="search-item-quantity-p-span">
                              {product?.waterQuantity}ml
                            </span>
                          </p>
                          <p className="search-item-quantity-p flex-row align-items-center  ">
                            Supplier :{" "}
                            <span className="search-item-quantity-p-span">
                              {result?.supplierName}
                            </span>
                          </p>
                        </span>

                        <span className="search-item-pricing">
                          SAR {result?.price}
                        </span>
                      </span>
                    </span>
                  </NavLink>
                )}
              </Fragment>
            );
          })
        ) : searchQuery?.length > 0 && searched ? (
          <div className="product-search-no-results flex-column gap-1 ">
            <Lottie options={noResultFound} height={350} width={350} />
            <span>No results found</span>
          </div>
        ) : (
          <div className="product-search-no-results">
            {featured?.length > 0
              ? featured?.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <NavLink to={`/product/${item?.id}`}>
                        <span className="navbar-search-results-item w-100 flex-row  gap-1">
                          <span className="navbar-search-results-item-img flex-row align-items-center justify-content-center">
                            <img src={item?.images[0]?.url} alt="product" />
                          </span>

                          <span className="navbar-search-results-item-details flex-column gap-1">
                            <h3 className="navbar-search-results-item-details-name">
                              {item?.name}
                            </h3>

                            <span className="search-item-quantity flex-column">
                              <p className="search-item-quantity-p flex-row align-items-center  ">
                                Quantity :{" "}
                                <span className="search-item-quantity-p-span">
                                  {item?.waterQuantity}ml
                                </span>
                              </p>
                              <p className="search-item-quantity-p flex-row align-items-center  ">
                                Supplier :{" "}
                                <span className="search-item-quantity-p-span">
                                  {item?.supplierName}
                                </span>
                              </p>
                            </span>

                            <span className="search-item-pricing">
                              SAR {item?.price}
                            </span>
                          </span>
                        </span>
                      </NavLink>
                    </Fragment>
                  );
                })
              : "Search for products"}
          </div>
        )}
      </div>
    </Container>
  );
};

export default SearchUi;
